import React, { useState } from 'react';
import { Modal, Button, Icon } from 'semantic-ui-react';
import { ToastsStore } from 'react-toasts';
import Chips from 'react-chips';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { removeTagsDigests, fetchTagsData } from '../../Api';

const ChipWrapper = styled.div`
  position: relative;
  background-color: rgb(233, 233, 233);
  color: rgb(128, 128, 128);
  font-size: 14px;
  font-weight: 500;
  padding: 5px 30px 5px 10px;
  margin: 0 10px 0 0px;
  border-radius: 4px;
  font-family: Metropolis, sans-serif;
`;

const ChipCloseIcon = styled.div`
  background-color: #fff;
  padding: 1px 2px;
  position: absolute;
  top: 4px;
  right: 2px;
  border-radius: 50%;
  cursor: pointer;
  i {
    color: rgb(128, 128, 128);
    margin: 0;
  }
`;

const Wrapper = styled.div`
  #react-autowhatever-1 {
    background-color: #000;
    ul {
      max-height: 150px;
      overflow: auto;
    }
  }
`;

const RemoveTagsModal = ({ onCloseModal, digestIds }) => {
  const [removeTagsLoading, setRemoveTagsLoading] = useState(false);
  const [selectedTags, setSelectedTags] = useState([]);
  const [selectedChipIdsTags, setSelectedChipIdsTags] = useState([]);

  const hanldeRemoveTags = (chips) => {
    // const tags = { ...chips[chips.length - 1] };
    setSelectedTags(chips);
    setSelectedChipIdsTags(chips.map((chip) => chip.id));
  };

  const fetchTagSuggestions = async (value, chips) => {
    try {
      const response = await fetchTagsData({ searchString: value });
      const data = response.data.results;
      return data.filter((item) => !selectedChipIdsTags.includes(item.id));
      // eslint-disable-next-line no-empty
    } catch (error) {}
    return [];
  };

  const createTagsPostObject = (data) =>
    data.map((item) => {
      if (typeof item === 'string') {
        return item;
      }
      return item.id;
    });

  return (
    <Modal size="tiny" open onClose={() => {}}>
      <Modal.Header>Remove Tags</Modal.Header>
      <Modal.Content>
        <Wrapper>
          <Chips
            placeholder="Remove tags"
            value={JSON.parse(JSON.stringify(selectedTags))}
            onChange={hanldeRemoveTags}
            fetchSuggestions={fetchTagSuggestions}
            // alwaysRenderSuggestions={true}
            // createChipKeys={[13]}
            title="Tag"
            renderChip={(chipData) => (
              <ChipWrapper>
                {chipData.title || chipData}
                <ChipCloseIcon
                  onClick={() => {
                    let index;
                    if (chipData.id)
                      index = selectedTags.findIndex((tag) => tag.id === chipData.id);
                    else index = selectedTags.findIndex((tag) => tag === chipData);
                    const tagsData = JSON.parse(JSON.stringify(selectedTags));
                    tagsData.splice(index, 1);
                    hanldeRemoveTags(tagsData);
                  }}
                >
                  <Icon size="small" name="close" />
                </ChipCloseIcon>
              </ChipWrapper>
            )}
            renderSuggestion={(data) => <span>{data.title}</span>}
            suggestionsFilter={(opt, val) =>
              selectedTags.findIndex((tag) => tag.id === opt.id) === -1
            }
          />
        </Wrapper>
      </Modal.Content>
      <Modal.Actions>
        <Button
          negative
          disabled={removeTagsLoading}
          onClick={() => {
            onCloseModal();
          }}
        >
          Cancel
        </Button>
        <Button
          positive
          content="Remove Tags"
          disabled={removeTagsLoading || (selectedTags || []).length === 0}
          onClick={() => {
            setRemoveTagsLoading(true);
            removeTagsDigests({ digests: digestIds, tags: createTagsPostObject(selectedTags) })
              .then(() => {
                onCloseModal();
                ToastsStore.success('Tags removed successfully.');
              })
              .catch((error) => {
                if (window) window.Raven.captureException(error.response);
                onCloseModal();
                if (error.response.status === 400) {
                  ToastsStore.error(
                    (error.response.data &&
                      error.response.data.title &&
                      error.response.data.title[0]) ||
                      'Something went wrong',
                  );
                } else {
                  ToastsStore.error(
                    (error.response && error.response.message) || 'Something went wrong',
                  );
                }
              });
          }}
        />
      </Modal.Actions>
    </Modal>
  );
};

RemoveTagsModal.propTypes = {
  onCloseModal: PropTypes.func,
  digestIds: PropTypes.array,
};

export default RemoveTagsModal;
